import React from 'react';
// import { Navigate, useParams } from "react-router-dom";

// import {
//   Grid, 
//   Button, 
// } from "@mui/material";
// import {
//   ArmorType, 
// } from "../../models";
// import { ModelBase } from '../../../../models';

// import API from "../../utilities/system_api";
// import DataUtilities from '../../utilities/common_utilities';

// import SelectStringBox from '../../../../components/input/selects/SelectStringBox';
// import CheckBox from "../../../../components/input/CheckBox";

// import ModelBaseInput from "../../components/ModelBaseInput";
// import LoadingBox from '../../../../components/input/LoadingBox';

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();

export default function ArmorTypeEdit() {
  // const { id } = useParams();
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [reloading, setReloading] = useState(false);
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  // const [obj, setObj] = useState<ArmorType>(api.working_on_sb === null ? new ArmorType() : new ArmorType({ source_books: [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }] }));
  // const [change_time, setChangeTime] = useState(0);
  
  // const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  // useEffect(() => {
  //   if(!fetched) {
  //     load();
  //   }
  // });
    
  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  // const load = () => {
  //   setFetched(true);
  //   // debugger;
  //   if (id && id !== "") {
  //     setLoading(true);
  //     load_object(id);
  //   } else {
  //     // It's here from clicking Create on index.  
  //     // If the user is not admin, then we need to give the floating feature their id as owner or it will be disabled.
  //     const new_obj = obj;
  //     if (api.user && !api.user.admin && new_obj.name === "" && new_obj.owner_id === "") {
  //       new_obj.owner_id = api.user._id;
  //     }
  //     setObj(new_obj);
  //   }
  // }

  // // Loads the editing Creature into state
  // const load_object = (id: string) => {
  //   setLoading(true);
  //   api.getFullObject("armor_type", id).then(res => {
  //     if (res instanceof ArmorType) {
  //       setObj(res);
  //       setLoading(false);
  //     }
  //   });
  // }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("armor_type", obj).then(res => {
  //       console.log(res);
  //       if (res && res.body.id) {
  //         obj._id = res.body.id;
  //       }
  //       setProcessing(false);
  //       setNavigateTo(`/dandd/armor_type`);
  //     });
  //   }
  // }
  
  // const height = window.innerHeight - 64;
  // if (!fetched || loading) {
  //   return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  // } else if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  // } else {
  //   return (
  //     <Grid container spacing={0} direction="column">
  //       <Grid item 
  //         style={{ 
  //           height: `calc(100vh - 165px)`, 
  //           overflowY: "scroll", 
  //           overflowX: "hidden" 
  //         }}>
  //         <Grid container spacing={0} direction="column">
  //           <ModelBaseInput 
  //             obj={obj}
  //             disabled={disabled}
  //             change_time={change_time}
  //             onChange={(changed: ModelBase) => {
  //               if (changed instanceof ArmorType) {
  //                 const new_obj = obj;
  //                 new_obj.copy(changed);
  //                 setObj(new_obj);
  //                 setChangeTime(common_util.get_time_number());
  //               }
  //             }}
  //           />
  //           <Grid item>
  //             <SelectStringBox 
  //               name="DEX Bonus Max"
  //               value={ obj.dex_bonus_max === null ? "None" : (obj.dex_bonus_max ? "2" : "0") } 
  //               options={["None","0","2"]}
  //               disabled={disabled}
  //               onChange={(changed: string) => {
  //                 const new_obj = obj;
  //                 switch(changed) {
  //                   case "None": new_obj.dex_bonus_max = null; break;
  //                   case "2": new_obj.dex_bonus_max = true; break;
  //                   case "0": new_obj.dex_bonus_max = false; break;
  //                 }
  //                 setObj(new_obj);
  //                 setChangeTime(common_util.get_time_number());
  //               }}
  //             />
  //           </Grid>
  //           <Grid item>
  //             <CheckBox 
  //               value={obj.stealth_disadvantage} 
  //               name="Disadvantage on Stealth"
  //               disabled={disabled}
  //               onChange={(changed: boolean) => {
  //                 const new_obj = obj;
  //                 new_obj.stealth_disadvantage = changed;
  //                 setObj(new_obj);
  //                 setChangeTime(common_util.get_time_number());
  //               }}
  //             />
  //           </Grid>
  //         </Grid>
  //       </Grid>
  //       { !disabled &&
  //         <Grid item>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             disabled={processing}
  //             onClick={submit}>
  //             Submit
  //           </Button>
  //           <Button
  //             variant="contained"
  //             disabled={processing}
  //             style={{ marginLeft: "4px" }}
  //             onClick={ () => { 
  //               setNavigateTo(`/dandd/armor_type`);
  //             }}>
  //             Cancel
  //           </Button>
  //         </Grid>
  //       }
  //     </Grid>
  //   ); 
  // }
  return <></>;
}